import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  float: left;
  padding: 40px 0;
`;

export const Content = styled.div`
  width: 90%;
  margin: 0 5%;

  @media (min-width: 64.5em) {
    width: 95%;
    max-width: var(--max-width-content);
    margin: 0 auto;
  }
`;

export const Clear = styled.div`
  clear: both;
`;